var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "navbar navbar-expand-lg navbar-dark bg-dark" },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse navbar-collapse",
            attrs: { id: "navbarSupportedContent" },
          },
          [
            _c(
              "ul",
              { staticClass: "navbar-nav me-auto mb-2 mb-lg-0" },
              _vm._l(_vm.menuItems, function (item, index) {
                return _c(
                  "li",
                  { key: index, staticClass: "nav-item dropdown" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "nav-link dropdown-toggle",
                        attrs: {
                          to: item.to ?? "#",
                          id: `navbar-dropdown-masterps-${index}`,
                          role: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(item.title) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    item.children && item.children.length > 0
                      ? _c(
                          "ul",
                          {
                            staticClass: "dropdown-menu",
                            attrs: {
                              "aria-labelledby": `navbar-dropdown-masterps-${index}`,
                            },
                          },
                          _vm._l(item.children, function (child, childIndex) {
                            return _c(
                              "li",
                              { key: childIndex, staticClass: "nav-item" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: { to: child.to },
                                  },
                                  [
                                    _c("i", { class: child.icon }),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(child.title)
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }